// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__3WKWI","img":"styles_img__38Njc","testTitle":"styles_testTitle__3ey_5","serviceAdditionalInformation":"styles_serviceAdditionalInformation__1Ft1a"};